

export const isAdmin = (userData) => {
  if (!userData) return
  
  return userData?.role === 'admin'
}